import React from 'react';

import { Carousel } from 'react-responsive-carousel';
import { RiArrowLeftSFill, RiArrowRightSFill } from 'react-icons/ri';

import TestimonialCard from '../../cards/TestimonialCard/TestimonialCard';

import './Testimonials.css';

const Testimonials = () => {
  return (
    <div className='testimonials-container'>
      <h1>TESTIMONIALS</h1>
      <div className='testimonials-carousel-with-btns-container'>
        <Carousel
          showArrows={true}
          autoPlay={true}
          interval={3000}
          infiniteLoop={true}
          showThumbs={false}
          showStatus={false}
          renderArrowPrev={(clickHandler, hasPrev) => {
            return (
              <div
                className='testimonials-carousel-arrow-prev-container'
                onClick={clickHandler}
              >
                <RiArrowLeftSFill className='testimonials-carousel-arrow-prev' />
              </div>
            );
          }}
          renderArrowNext={(clickHandler, hasPrev) => {
            return (
              <div
                className='testimonials-carousel-arrow-next-container'
                onClick={clickHandler}
              >
                <RiArrowRightSFill className='testimonials-carousel-arrow-next' />
              </div>
            );
          }}
          className='testimonials-carousel'
        >
          <TestimonialCard
            stars={5}
            desc={
              'Top quality wellness facility in Vaughan with extremely knowledgeable staff who provide high quality services. I have been seeing the strength rehab trainer, Cesar for almost 7 years following a motor vehicle accident. This rehabilitation has significantly helped me to get back on track and regain muscle strength following my injuries. The chiropractor and massage therapist at this clinic are also fantastic. Will continue to be a regular customer here.'
            }
            name={'Natalie G'}
          />
          <TestimonialCard
            stars={5}
            desc={
              'I have been receiving amazing treatment here for about 5 years. I went from not being able to walk to working out daily. Encouraging, patient, empathetic, knowledgeable are just a few of the fantastic traits that all staff have. I have brought my family into this clinic and they also have received life changing treatment. I would truly reccomend coming to Pro Evolution and experiencing the fantastic treatment for your self. You will not regret it.'
            }
            name={'Erica F'}
          />
          <TestimonialCard
            stars={5}
            desc={
              'I have tried other wellness clinics and their services do not compare to the team they have here. If you like wasting your time and money in a physio clinic where they do nothing but sit you down on a massage chair then this is not a place for you.I only trust Cesar and his team to maintain my back injury. They really care about your well-being and make sure you are well taken care of.'
            }
            name={'John L'}
          />
          <TestimonialCard
            stars={5}
            desc={`Cesar and his team are outstanding. Firstly, Cesar's passion for educating his clients about their own body and what works for them is hard to find elsewhere. I feel like I'm getting genuine attention on what my needs are and setting goals to accomplish them. Rupina and Fairy have been amazing at helping me ease the pain and heal from a bruised tailbone. They actively help you to focus on your area of pain and don't just set you up to machines and leave the room. The level of attention and energy this team puts into their clients is something I haven't been able to find anywhere else!`}
            name={'Jenna C'}
          />
          <TestimonialCard
            stars={5}
            desc={
              'I’ve been at Pro Evolution a little over two years. Cesar, the owner, is a kind, understanding, knowledgeable therapist who will help you heal from whatever ache or pain you’re dealing with. He puts his 100% and invests time and energy to make sure you leave better than when you arrived. I have lower back issues, shoulder/rotator cuff issues, arthritis and he has helped, continues to help ensure I leave my appointment feeling better then when I arrived.'
            }
            name={'Maria F'}
          />
        </Carousel>

        <div className='testimonial-btns'>
          <a
            href='https://www.google.com/search?q=pro+evolution+wellness&rlz=1C5CHFA_enCA1007CA1008&oq=pro+evolution&aqs=chrome.0.35i39j46i175i199i512j69i57j46i512l2j69i60l3.2137j0j7&sourceid=chrome&ie=UTF-8#lrd=0x882b2531610a3123:0xbb1dcdb52405cb2b,1,,,,'
            target='_blank'
            rel='noreferrer'
            referrerPolicy='no-referrer'
          >
            View All Reviews
          </a>
          <a
            href='https://www.google.com/search?q=pro+evolution+wellness&rlz=1C5CHFA_enCA1007CA1008&oq=pro+evolution&aqs=chrome.0.35i39j46i175i199i512j69i57j46i512l2j69i60l3.2137j0j7&sourceid=chrome&ie=UTF-8#lrd=0x882b2531610a3123:0xbb1dcdb52405cb2b,1,,,,'
            target='_blank'
            rel='noreferrer'
            referrerPolicy='no-referrer'
          >
            Write Review
          </a>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
